export default "__VITE_ASSET__DOVKd5M$__"